import { useTranslation } from 'react-i18next';
import { Flag } from '@/components/Flag';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
];

const supportedCodes = languages.map((lang) => lang.code);

export const LanguageSwitcher = ({
  compact = false,
  className,
}: {
  compact?: boolean
  className?: string
} = {}) => {
  const { i18n } = useTranslation();

  const detectedLang = i18n.language?.split('-')[0] || 'en';
  const currentLang = supportedCodes.includes(detectedLang) ? detectedLang : 'en';

  const handleLanguageChange = (value: string) => {
    i18n.changeLanguage(value);
  };

  return (
    <Select value={currentLang} onValueChange={handleLanguageChange}>
      <SelectTrigger
        className={cn(
          '[&>span]:!flex',
          compact
            ? 'h-8 w-8 justify-center p-0 [&>svg]:hidden'
            : 'w-[160px]',
          className
        )}
      >
        <span className="flex items-center gap-2">
          <Flag code={currentLang} />
          {!compact && (
            <span>{languages.find((lang) => lang.code === currentLang)?.name}</span>
          )}
        </span>
      </SelectTrigger>
      <SelectContent>
        {languages.map((lang) => (
          <SelectItem key={lang.code} value={lang.code}>
            <span className="flex items-center gap-2">
              <Flag code={lang.code} />
              <span>{lang.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

